import * as React from 'react';
import { SVGProps } from 'react';

const IconSelectOpenSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="m8 5-4.5 5h9L8 5Z" />
  </svg>
);
export default IconSelectOpenSizeS;
